import React, { useContext } from "react";
import { useEffect, useState } from "react";
// import "./facility.scss";
import OPPCss from "../../Dashboard/Opportunities/Opportunities.module.scss";
import Sidebar from "../Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import noImg from "../../../assets/noImage.jpeg";
import Loader from "../../../components/Loader/Loader";
import notAvail from "../../../assets/notAvail.png";
import { toast } from "react-toastify";
import AddInvestment from "../Investment/AddInvestment/AddInvestment";

function FacilityList() {
  const navigate = useNavigate();

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [scope, setScope] = useState("");
  const [sortByHidden, setSortByHidden] = useState(true);
  const [approved, setApproved] = useState([]);
  const [underReview, setUnderReview] = useState([]);
  const [declined, setDeclined] = useState([]);
  const [all, setAll] = useState([]);

  const fetchFacilities = async () => {
    setLoading(true);
    const token = localStorage.getItem("access_token");
    try {
      const response = await fetch(
        "https://ballersapi.ballerslife.co/api/v1/admin/membership/get_all_facility",
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setFacilities(data);
      setLoading(false);
    } catch (err) {
      //   setError(err.message);
    }
  };

  const [addInvestment, setAddInvestment] = useState(false);
  const handleAddInvestment = async () => {
    navigate("/admin/facility/add");
    setAddInvestment(!addInvestment);
  };
  const handleInvestmentDetail = (facility, index) => () => {
    console.log(facility, index);
    navigate(`/admin/facility/details/${facility.facility_id}`, {
      state: { facility: facility.facility_id },
    });
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  const formatNumber = (num) => {
    let formattedNumber;
    if (num >= 1000000000) {
      formattedNumber = (num / 1000000000).toFixed(1) + "B";
    } else if (num >= 1000000) {
      formattedNumber = (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      formattedNumber = (num / 1000).toFixed(1) + "K";
    } else {
      return num?.toString();
    }
    if (
      formattedNumber.endsWith(".0K") ||
      formattedNumber.endsWith(".0M") ||
      formattedNumber.endsWith(".0B")
    ) {
      formattedNumber =
        formattedNumber.slice(0, -3) + formattedNumber.slice(-1);
    }
    return formattedNumber;
  };

  useEffect(() => {
    document.title = ` Facility | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div>
              <div className="btnMainPort">
                <p className="addBtn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffcc14"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-plus"
                    onClick={handleAddInvestment}
                  >
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                  </svg>
                </p>
              </div>
              <>
                {facilities.map((facility, index) => {
                  return (
                    <div>
                      <div className={OPPCss.invDetailMain}>
                        <div
                          className="invDetailSec"
                          key={index}
                          onClick={handleInvestmentDetail(facility, index)}
                        >
                          <div className="invContAndImgInvest">
                            <div>
                              {facility?.facility_image == null ? (
                                <img src={noImg} alt="" />
                              ) : (
                                <img src={facility.facility_image} alt="" />
                              )}
                            </div>
                            <div>
                              <p className="investmentHeader">FACILITY NAME</p>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: facility.facility_name,
                                }}
                              >
                                {/* {facility.club_name} */}
                              </p>
                            </div>
                          </div>
                          <div className="invCont">
                            <p className="investmentHeader">CITY</p>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: facility.city,
                              }}
                            >
                              {/* {facility.league_name} */}
                            </p>
                          </div>

                          <div className="invCont">
                            <p className="investmentHeader">LOCALITY</p>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: facility.locality,
                              }}
                            ></p>
                          </div>
                          <div className="invCont">
                            <p className="investmentHeader">STATUS</p>
                            <p>{facility.status}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            </div>
            {addInvestment ? (
              <div className="userAccessStatusMain">
                <AddInvestment
                  handleAddInvestment={handleAddInvestment}
                  fetchInvestment={fetchFacilities}
                />
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default FacilityList;
